import type { consent } from '@axo/shared/data-access/types';
import { MarketCountryCode } from '@axo/shared/types';
import { IAPI } from '../../lib/models/api';
import { send } from '../../lib/send';
import { ConsentData, PartnerConsentChanges } from '@axo/shared/data-access/types/consent';

export const getConsentConfig =
  (baseURL: string) =>
  async (country: MarketCountryCode): Promise<consent.ConsentConfigSnapshot> =>
    send({
      baseURL,
      path: `/consent/v1/config/snapshot/${country}`,
      method: 'GET',
    });

export const getConsent =
  ({ url: { service: baseUrl }, token }: IAPI) =>
  async ({
    country,
    customerID,
  }: {
    country: MarketCountryCode;
    customerID: string;
  }): Promise<consent.ConsentConfigData> =>
    send({
      baseURL: baseUrl,
      token,
      path: `/consent/v1/consent/${country}/${customerID}`,
      method: 'GET',
    });

export const sendMasterConsent =
  ({ url: { service: baseUrl }, token }: IAPI) =>
  async (data: consent.ConsentConfigData) =>
    send({
      baseURL: baseUrl,
      token,
      path: '/consent/v1/consent',
      method: 'POST',
      body: data,
    });

export const getConsentPartners =
    ({ url: { service: baseUrl }, token }: IAPI) =>
    async () =>
      send<void, consent.Partner[]>({
        baseURL: baseUrl,
        token,
        path: '/consent/v1/partner',
        method: 'GET',
      });

export const getConsentItemsByCustomer =
  ({ url: { service: baseUrl }, token }: IAPI) =>
  async ({
    country,
    customerID,
  }: {
    country?: MarketCountryCode;
    customerID?: string;
  }) =>
    send<void, consent.ConsentItems>({
      baseURL: baseUrl,
      token,
      path: `/consent/v1/consent/${country}/${customerID}/items`,
      method: 'GET',
    });

export const updateConsentItemsByCustomer =
  ({ url: { service: baseUrl }, token }: IAPI) =>
  async ({
    country,
    customerID,
    patchData,
  }: {
    country?: MarketCountryCode;
    customerID?: string;
    patchData?: PartnerConsentChanges;
  }) =>
    send({
      baseURL: baseUrl,
      token,
      path: `/consent/v1/consent/${country}/${customerID}`,
      method: 'PATCH',
      body: patchData,
    });